import React from "react";
import "./index.scss";

function ModalOrderDetail({ order, closeModal }: any) {
  return (
    <div className="modal-order-detail">
      <div className="modal-order-header">
        <h2>🧾 Résumé de commande</h2>
        <i
          className="bx bx-x"
          style={{ fontSize: 26 }}
          onClick={() => closeModal()}
        ></i>
      </div>

      <div className="modal-order-body">
        {/* Informations client */}
        <div className="order-section">
          <h3>Informations du client</h3>
          <div className="info-pair">
            <span>👤 Nom :</span> {order?.user?.name}
          </div>
          <div className="info-pair">
            <span>📞 Téléphone :</span> {order?.phoneNumber}
          </div>
          <div className="info-pair">
            <span>📍 Adresse :</span> {order?.deliveryAddress?.address}
          </div>
        </div>

        {/* Informations commande */}
        <div className="order-section">
          <h3>Informations de la commande</h3>
          <div className="info-pair">
            <span>🆔 N° de commande :</span> {order?.transaction_id}
          </div>
          <div className="info-pair">
            <span>💰 Total :</span> {order?.amount} DT
          </div>
        </div>
      </div>

      <div className="modal-order-items">
        <h3>🛒 Articles commandés</h3>
        <table>
          <thead>
            <tr>
              <th>Produit</th>
              <th>Qté</th>
              <th>Prix (DT)</th>
              <th>Total (DT)</th>
            </tr>
          </thead>
          <tbody>
            {order?.products.map((item: any, index: number) => (
              <tr key={index}>
                <td>{item?.name}</td>
                <td>{item?.count}</td>
                <td>{item?.price}</td>
                <td>{(item?.price * item?.count).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ModalOrderDetail;
